export class AddFieldsVM {
    userID: string;
    databaseID:number;
    fieldName: string;
    fieldTypeID: number;
    fieldTypeName: string;
    folderID: number;
    folderName: string;
    position: number;
    defaultValue: string;
    isRequired: boolean;
    isDeactivated: boolean;
    fieldFolderType: number;
    placeholder: string;
    organizationID: number;
    officeID:number;
    OfficeIDList:any
}



export class AddCreadField  {
    userID: string = '';
    databaseID: Number =  0;
    fieldName: string = '';
    fieldTypeID: Number =  0;
    position:  Number =  0;
    defaultValue: string = '';
    fieldCategotyTypeID:  Number =  0;
    organizationID:  Number =  0;
    selectedFolders: [
      {
        folderID:  Number ;
        subFolderID: Number ;
        position: Number ;
        viewOrder:  Number;
      }
    ];
    fieldNames:null
    
  }

export class ReorderPositionVm {
    fieldID:number;
    folderID:number;   
    subFolderID:number
    previousPosition:number;
    currectPosition:number;
    userID: string;
    databaseID: number;
    organizationID: number; 
    fieldGroupID:number;
    isRemove:boolean;
    isGroupMove:boolean;  
    fieldData:FieldData[];
    OfficeIDList:any;
    officeID:number;       
}

export class FieldData{
    fieldID:number;
    position:number;              
}

export class AddEditGroupVm {
  FolderID:number;
  OrganizationID: number; 
  FieldGroupID:number;
  GroupName:string;
  OfficeIDList:any;
  officeID:number;           
}
